import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from "@angular/core";
import {bzIconFilter} from '@bringoz/ui/icons';
import {BranchModel} from "../../../../branches/models/branch.model";
import {BranchReferenceModel} from "../../../../branches/models/branch-reference.model";
import {SiteFiltersType} from "../../../types/site-filters.type";

require('./branches-indicator.scss');
@Component({
  standalone: false,
  selector: 'branches-indicator',
  templateUrl: './branches-indicator.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BranchesIndicatorComponent implements OnChanges {

  readonly icons = {filter: bzIconFilter};
  @Input() branches: BranchModel[] | BranchReferenceModel[];
  @Input() branchIds: string[];
  @Input() isMultiline: boolean;
  @Input() isShowFilterByButton: boolean;
  @Input() openInNewTab: boolean;

  @Output() filterEvent = new EventEmitter<any>();


  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
  public isShowActions: boolean = false;


  constructor(@Inject('$branches') private $branches, @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.branchIds) {
      if (this.branchIds && this.branchIds.length) {
        this.getBranches()
      }
    }
  }

  filterByTypeEvent($event) {
    $event.stopPropagation();
    this.filterEvent.emit({type: this.siteFiltersType.branchIds, value: this.branches.map((b) => b.id)});
  }

  private getBranches() {
    this.branches = [];
    this.$branches().$asyncValues(this.branchIds)
      .then((branches: BranchModel[]) => {
        this.branches = branches;
        this.cdr.detectChanges();
      })
  }
}
